import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const documentTypes = {
    cashSales: "cash_sales",
    deliveryOrder: "delivery",
    replacementDelivery: "replacement_delivery",
    itemReceive: "item_receive",
    itemTransfer: "item_transfer",
    tripOrder: "trip",
    purchaseReturn: "purchase_return",
    salesCreditNote: "sales_credit_note",
    salesDebitNote: "sales_debit_note",
    itemAdjustment: "item_adjustment",
    itemIssue: "item_issue",
    transferReturn: "transfer_return"
}

export const targetTypes = {
    cashSales: "cash_sales",
    deliveryOrder: "delivery",
    replacementDelivery: "replacement_delivery",
    itemReceive: "item_receive",
    itemTransfer: "item_transfer",
    tripOrder: "trip",
    purchaseReturn: "purchase_return",
    salesCreditNote: "sales_credit_note",
    salesDebitNote: "sales_debit_note",
    itemAdjustment: "item_adjustment",
    itemIssue: "item_issue",
    transferReturn: "transfer_return"
}

export const actionTypes = {
    verifyIn: {
        itemReceive: "ir_verify_in",
        tripOrder: "trip_onload",
        salesCreditNote: "scn_verify_in",
        itemAdjustment: "ia_verify_in"
    },
    undoVerifyIn: {
        itemReceive: "ir_unverify_in",
        tripOrder: "", // ??
        salesCreditNote: "scn_unverify_in",
        itemAdjustment: "ia_unverify_in"
    },
    verifyTransferIn: {
        itemTransfer: "it_verify_in",
        transferReturn: "tr_verify_in"
    },
    undoVerifyTransferIn: {
        itemTransfer: "it_unverify_transfer_in",
        transferReturn: "tr_unverify_transfer_in",
    },
    verifyOut: {
        cashSales: "cs_verify_out",
        deliveryOrder: "do_verify_out",
        replacementDelivery: "rdo_verify_out",
        itemTransfer: "it_verify_out",
        tripOrder: "trip_unload",
        purchaseReturn: "pr_verify_out",
        salesDebitNote: "sdn_verify_out",
        itemAdjustment: "ia_verify_out",
        itemIssue: "ii_verify_out",
        transferReturn: "tr_verify_out"
    },
    undoVerifyOut: {
        cashSales: "cs_unverify_out",
        deliveryOrder: "do_unverify_out",
        replacementDelivery: "rdo_unverify_out",
        itemTransfer: "it_unverify_out",
        tripOrder: "", // ???
        purchaseReturn: "pr_unverify_out",
        salesDebitNote: "sdn_unverify_out",
        itemAdjustment: "ia_unverify_out",
        itemIssue: "ii_unverify_out",
        transferReturn: "tr_unverify_out"
    },
}

export const verifyOutDeductionTypes = {
    specific: "specific",
    fifo: "fifo",
    lilo: "lilo"
}

export function useDocumentValidation({ 
    documentType: _documentType = "",
    targetType: _targetType = "", 
    actionType: _actionType = ''
}) {

    const [documentType, setDocumentType] = useState(_documentType);
    const [targetType, setTargetType] = useState(_targetType);
    const [actionType, setActionType] = useState(_actionType);

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint1 = "documents";
    const endpoint2 = "document";

    // const list = async (props) => {

    //     setIsLoading(true);

    //     try{

    //         const {
    //             documentType: overrideDocumentType,
    //             customEndpoint: overrideCustomEndpoint
    //         } = props;

    //         let endpoint = `${endpoint1}/${documentType}`

    //         if(overrideDocumentType){
    //             endpoint = `${endpoint1}/${overrideDocumentType}`
    //         }

    //         let url = getListsUrl(`${endpoint}`, props);

    //         if(targetType){
    //             url = getListsUrl(`${endpoint}/${targetType}`, props);
    //         }

    //         // for custom endpoint
    //         if(customEndpoint){
    //             url = getListsUrl(`${endpoint2}/${customEndpoint}`, props)
    //         }

    //         if(overrideCustomEndpoint){
    //             url = getListsUrl(`${endpoint2}/${overrideCustomEndpoint}`, props)
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "GET",
    //             payload: {}
    //         });

    //         setIsLoading(false);

    //         return response;

    //     }catch(error){

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    // const create = async ({ data }) => {

    //     setIsLoading(true)

    //     try{

    //         const url = endpoint2;

    //         const postData = {
    //             scope: {
    //                 target: targetType,
    //                 action: "",
    //             },
    //             payload: data
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "POST",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     }catch(error){

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    // const update = async ({ id, data }) => {

    //     setIsLoading(true)

    //     try{

    //         const url = `${endpoint2}/${id}`

    //         const postData = {
    //             scope: {
    //                 target: targetType,
    //                 action: "",
    //             },
    //             payload: data
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "PUT",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     }catch(error){

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    // const remove = async ({ ids, documentType: _documentType, targetType: _targetType }) => {

    //     // blocked the retail or cash sales from remove - only cancel
    //     if(_documentType){
    //         if(_documentType === documentTypes.cashSales || _documentType === documentTypes.retailCashSales){
    //             throw new Error(`Remove document not supported for ${_documentType}`);
    //         }
    //     }

    //     if(documentType){
    //         if(documentType === documentTypes.cashSales || documentType === documentTypes.cashSales){
    //             throw new Error(`Remove document not supported for ${documentType}`);
    //         }
    //     }

    //     setIsLoading(true);

    //     if(ids.length <= 0){
    //         throw getError(false, `Please select at least (1) items`)
    //     }

    //     try{

    //         let url = `${endpoint1}/delete`

    //         if(_documentType){
    //             url = `${endpoint1}/${_documentType}/delete`
    //         }

    //         const postData = {
    //             scope: {
    //                 target: targetType
    //             },
    //             payload: {
    //                 ids
    //             }
    //         }

    //         if(_targetType) postData.scope.target = _targetType

    //         const response = await makeCall({
    //             url,
    //             method: "POST",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     }catch(error){

    //         setIsLoading(false);
    //         throw error;

    //     }

    // } 

    const listVerifyInSaved = async ({ id, itemId, dataTypesArray = [] }) => {

        setIsLoading(true);

        if (!itemId) {
            throw new Error(`Item Id is required`)
        }

        try {

            let url = `${endpoint2}/${documentType}`

            if (getUrlWithDataTypes.length) {
                url = getUrlWithDataTypes(`${url}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            const {
                items
            } = response?.data ? response.data : {}

            const data = items.filter(i => i.item_id === itemId)

            return data.length ? data[0]?.verify_in_uids : []


        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const performVerifyIn = async ({ id, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/verify_in/${id}`

            const postData = {
                scope: {
                    target: targetType,
                    action: actionType,
                },
                payload: {
                    actions: {
                        items: data
                    }
                }
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const performUnVerifyIn = async ({ id, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/unverify_in/${id}`

            const postData = {
                scope: {
                    target: targetType,
                    action: actionType,
                },
                payload: {
                    actions: {
                        items: data
                    }
                }
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const performVerifyTransferIn = async ({ id, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/verify_transfer_in/${id}`

            const postData = {
                scope: {
                    target: targetType,
                    action: actionType,
                },
                payload: {
                    actions: {
                        items: data
                    }
                }
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const performUnVerifyTransferIn = async ({ id, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/unverify_transfer_in/${id}`

            const postData = {
                scope: {
                    target: targetType,
                    action: actionType,
                },
                payload: {
                    actions: {
                        items: data
                    }
                }
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const listVerifyTransferInSaved = async ({ id, itemId, dataTypesArray = [] }) => {

        setIsLoading(true);

        if (!itemId) {
            throw new Error(`Item Id is required`)
        }

        try {

            let url = `${endpoint2}/${documentType}`

            if (getUrlWithDataTypes.length) {
                url = getUrlWithDataTypes(`${url}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            const {
                items
            } = response?.data ? response.data : {}

            const data = items.filter(i => i.item_id === itemId)

            return data.length ? data[0]?.verify_in_uids : []


        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const listVerifyOutSaved = async ({ id, itemId, dataTypesArray = [] }) => {

        setIsLoading(true);

        if (!itemId) {
            throw new Error(`Item Id is required`)
        }

        try {

            let url = `${endpoint2}/${documentType}`

            if (getUrlWithDataTypes.length) {
                url = getUrlWithDataTypes(`${url}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            const {
                items
            } = response?.data ? response.data : {}

            const data = items.filter(i => i.item_id === itemId)

            return data.length ? data[0]?.verify_out_uids : []


        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const performVerifyOut = async ({ id, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/verify_out/${id}`

            const postData = {
                scope: {
                    target: targetType,
                    action: actionType,
                },
                payload: {
                    actions: {
                        items: data
                    }
                }
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const performUnVerifyOut = async ({ id, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/unverify_out/${id}`

            const postData = {
                scope: {
                    target: targetType,
                    action: actionType,
                },
                payload: {
                    actions: {
                        items: data
                    }
                }
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        filterOperatorTypes,
        isLoading,
        listVerifyInSaved,
        performVerifyIn,
        performUnVerifyIn,
        listVerifyTransferInSaved,
        performVerifyTransferIn,
        performUnVerifyTransferIn,
        listVerifyOutSaved,
        performVerifyOut,
        performUnVerifyOut
    }
}